<template>
  <el-dialog
    :visible.sync="editVisible"
    :close-on-click-modal="false"
    :before-close="clearEdit"
    width="600px"
    title="Improve product information"
  >
    <el-form :model="companydata" ref="companydata" :rules="rules" class="left inlineForm" style="overflow: auto;height: 500px;" @submit.native.prevent>
      <el-form-item label="Product image:" :label-width="formLabelWidth">
        <img :src="companydata.image" alt width="50" height="50">
      </el-form-item>
      <el-form-item label="SKU:" :label-width="formLabelWidth">
        <span>{{companydata.sku}}</span>
      </el-form-item>
      <el-form-item label="Inventory SKU:" :label-width="formLabelWidth" prop="cff_sku">
        <el-input v-model="companydata.cff_sku" autocomplete="off" class="widy"></el-input>
      </el-form-item>
      <el-form-item label="Product title:" :label-width="formLabelWidth" prop="desc_en">
        <el-input v-model="companydata.desc_en" autocomplete="off" class="widy"></el-input>
      </el-form-item>
      <el-form-item label="Chinese title:" :label-width="formLabelWidth" prop="desc_cn">
        <el-input v-model="companydata.desc_cn" autocomplete="off" class="widy"></el-input>
        <span @click="Translationtitle"  class="ckil">Translation</span>
      </el-form-item>
      <el-form-item label="Product description:" :label-width="formLabelWidth" prop="material_en">
        <el-input v-model="companydata.material_en" autocomplete="off" class="widy"></el-input>
      </el-form-item>
      <el-form-item label="Chinese description:" :label-width="formLabelWidth" prop="material_cn">
        <el-input v-model="companydata.material_cn" autocomplete="off" class="widy"></el-input>
        <span @click="Translationdescription" class="ckil">Translation</span>
      </el-form-item>
      <el-form-item label="Product Value:" :label-width="formLabelWidth" prop="price">
        <el-input v-model="companydata.price " autocomplete="off" class="widy"></el-input>
        <span>USD</span>
      </el-form-item>
      <el-form-item label="Declared value:" :label-width="formLabelWidth" prop="worth">
        <el-input v-model="companydata.worth" autocomplete="off" class="widy"></el-input>
        <span>USD</span>
      </el-form-item>

      <el-form-item label="Length*width*height:" :label-width="formLabelWidth">
        <el-input v-model="companydata.length" autocomplete="off" style="width:73px" ></el-input>
        <span>X</span>
        <el-input v-model="companydata.width" autocomplete="off" style="width:73px"></el-input>
        <span>X</span>
        <el-input v-model="companydata.height" autocomplete="off" style="width:73px"></el-input>
        <span>cm</span></br>
        <span class="fop">Actual measurement after storage</span>
      </el-form-item>
      <el-form-item label="Weight:" :label-width="formLabelWidth" prop="weight">
        <el-input v-model="companydata.weight" autocomplete="off" class="widy"></el-input>
        <span>KG</span></br>
        <span class="fop">Actual measurement after storage</span>
      </el-form-item>
      <el-form-item label="Barcode:" :label-width="formLabelWidth" prop="barcode">
        <el-input v-model="companydata.barcode" autocomplete="off" class="widy"></el-input>
        <!-- <span class="fop">Actual measurement after storage</span> -->
      </el-form-item>
      <el-form-item label="HS Code:" :label-width="formLabelWidth" prop="hs_code">
        <el-input v-model="companydata.hs_code" autocomplete="off" class="widy"></el-input>
        <span @click="Codequery"  class="ckil">HS Code</span>
      </el-form-item>
      <el-form-item label="Customs description:" :label-width="formLabelWidth" prop="remark">
        <el-input v-model="companydata.remark " autocomplete="off" class="widy"></el-input>
      </el-form-item>
      <el-form-item label="Usage:" :label-width="formLabelWidth" prop="purpose">
        <el-input v-model="companydata.purpose" autocomplete="off" class="widy"></el-input>
      </el-form-item>
      <el-form-item label="Place of origin:" :label-width="formLabelWidth" prop="origin">
        <el-input v-model="companydata.origin" autocomplete="off" class="widy"></el-input>
      </el-form-item>
      <!--外包装是否印有条码-->
      <!-- <el-form-item :label-width="formLabelWidth" label="Does the product has an existing barcode on it?" prop="is_label">
        <el-radio-group v-model="companydata.is_label" style="width: auto" @change="noticeDialogShow">
          <el-row style="padding-top:10px;">
            <el-radio label="0">No</el-radio>
            <el-radio label="1">Standard Barcode (4-15 characters)</el-radio>
          </el-row>
          <el-row style="padding-top:10px;">
            <el-radio label="2">Non-Standard Barcode (exceeding 15 characters)</el-radio>
          </el-row>
        </el-radio-group>
        <el-popover placement="top" width="600" style="margin-left: 10px;" trigger="hover">
          <div>
            <p style="line-height: 24px; font-size: 12px">A barcode is a machine-readable code in the form of numbers and a pattern of parallel lines of varying widths, printed on and identifying a product. It is used for scanning purpose. A typical barcode looks like this:</p>
            <img src="@/images/tipImg.png" alt="tipImg" style="width: 100%; height: auto;">
          </div>
          <el-button type="text" slot="reference">Learn More</el-button>
        </el-popover>
      </el-form-item> -->
      <el-form-item label="Whether to carry a battery:" :label-width="formLabelWidth">
        <el-radio v-model="companydata.withbattery" @change="batteryradio" label="0">NO</el-radio>
        <el-radio v-model="companydata.withbattery" @change="batteryradio" label="1">YES</el-radio>
      </el-form-item>
      <el-form-item label="Whether to carry liquid :" :label-width="formLabelWidth">
        <el-radio v-model="companydata.withliquid" @change="liquid" label="0">NO</el-radio>
        <el-radio v-model="companydata.withliquid" @change="liquid" label="1">YES</el-radio>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style=" text-align:center">
      <!-- <el-button @click="clearEdit()">取 消</el-button> -->
      <el-button type="primary" style="background:#8989ba;color:#fff;outline: none" @click="sub('companydata')">Confirm</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { productaddcff } from '../../api/product'
import $ from 'jquery'
export default {
  props: ['companydata', 'rolesList', 'visible'],
  data () {
    var cn = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Can not be empty'))
      }
      if (!/^[\u4e00-\u9fa5_0-9]+$/.test(value)) {
        callback(new Error('Must be Chinese'))
      } else {
        callback()
      }
    }

    var Price = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Can not be empty'))
      }
      if (!/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(Number(value))) {
        callback(new Error('please enter a number'))
      } else {
        callback()
      }
    }
    return {
      editVisible: false,
      form: this.companydata,
      formLabelWidth: '180px',
      rules: {
        cff_sku: [
          { required: true, message: ' Can not be empty', trigger: 'blur' }
        ],
        desc_en: [
          { required: true, message: ' Can not be empty', trigger: 'blur' }
        ],
        desc_cn: [
          { required: true, validator: cn, trigger: 'blur' }
        ],
        material_en: [
          { required: true, message: ' Can not be empty', trigger: 'blur' }
        ],
        material_cn: [
          { required: true, validator: cn, trigger: 'blur' }
        ],
        price: [
          { required: true, validator: Price, trigger: 'blur' }
        ],
        worth: [
          { required: true, validator: Price, trigger: 'blur' }
        ],
        weight: [
          { required: true, message: ' Can not be empty', trigger: 'blur' }
        ],
        hs_code: [
          { required: true, message: 'Can not be empty', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: 'Can not be empty', trigger: 'blur' }
        ],
        purpose: [
          { required: true, message: 'Can not be empty', trigger: 'blur' }
        ],
        origin: [
          { required: true, message: 'Can not be empty', trigger: 'blur' }
        ]

      }
    }
  },
  watch: {
    visible (val) {
      this.editVisible = val
    }
  },
  methods: {
    clearEdit () {
      this.editVisible = false
      // this.form=this.lids
      this.$emit('clearEdit')
    },
    Translationtitle () {
      this.translate(this.companydata.desc_en, 'desc_en')
    },
    Translationdescription () {
      this.translate(this.companydata.material_en, 'material_en')
    },

    translate (disj, tit) {
      let appid = '20190417000288845'
      let key = 'fkKfF7DO88DqlS8nBvzG'
      let salt = (new Date()).getTime()
      let query = disj
      let from = 'en'
      let to = 'zh'
      let str1 = appid + query + salt + key
      let sign = this.$md5(str1)
      let THat = this
      $.ajax({
        url: 'https://fanyi-api.baidu.com/api/trans/vip/translate',
        type: 'get',
        dataType: 'jsonp',
        data: {
          q: query,
          appid: appid,
          salt: salt,
          from: from,
          to: to,
          sign: sign
        },
        success: function (data) {
          if (tit == 'desc_en') {
            THat.companydata.desc_cn = data.trans_result[0].dst
          } else if (tit == 'material_en') {
            THat.companydata.material_cn = data.trans_result[0].dst
          }
          console.log(data)
        }
      })
    },
    Codequery () {
      window.open('https://www.tariffnumber.com/')
    },
    batteryradio (val) {
      console.log(val)
    },
    liquid (val) {
      console.log(val)
      console.log(this.form.liquid)
    },
    sub (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.companydata)
          let param = this.companydata
          productaddcff(param)
            .then(response => {
              console.log(response)
              if (response.data.ask == 1) {
                this.$emit('clearEdit')
                this.$parent.handleCurrentChange(1)
                // this.$emit("getproductlist", param);
                this.editVisible = false
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    }
  }
}
</script>
<style>
  .inlineForm .el-form-item__label{
    line-height: 30px !important;
  }
</style>
<style scoped>
.left {
  text-align: left;
  padding: 0;
}
.el-form-item {
  margin-bottom: 20px;
}
.widy {
  width: 250px;
}
.fop {
  color: #888888;
  font-size: 12px;
}
.title1 {
  color: #aeaece;
  border-left: 3px solid #aeaece;
  margin: 10px;
  padding-left: 5px;
  font-size: 16px;
  font-weight: bold;
}
.ckil{color: #8989ba;font-size: 14px;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/components/views/MyProducp/Editing/Editing.vue